import React = require('react');

export const MedicalInformation = () => {
  return (
    <div>
      <p>This information will be used to assess whether we are able to offer you quote.</p>
      <p><span className={'medical-declaration-text-sub'}>Pre-existing conditions:</span> Any illness, injury or medical
        condition that someone had at any time before buying insurance. Just so you know, we don't consider menopause to
        be a medical condition.</p>
      <p><span className={'medical-declaration-text-sub'}>Changes In Health:</span> You must tell us if any insured
        person is diagnosed with a new medical condition or awaiting
        a new medical diagnosis, or if their health changes (including any changes in medication, being placed on a
        waiting list for tests and/or investigations, treatment or admission to hospital) after you’ve bought the
        policy. Failure to do so could affect any future claims.</p>
      <p>
        If you are not sure what condition you or named travellers were seen for, check the below questions with your GP
        Surgery to ensure you make an accurate declaration when buying your policy. If you incorrectly declare medical
        conditions to us, this may affect any claim you make on the policy.
      </p>
    </div>
  )
}
